import { render, staticRenderFns } from "./BaseEX.vue?vue&type=template&id=fd287ce8&scoped=true&"
import script from "./BaseEX.vue?vue&type=script&lang=js&"
export * from "./BaseEX.vue?vue&type=script&lang=js&"
import style0 from "./BaseEX.vue?vue&type=style&index=0&id=fd287ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd287ce8",
  null
  
)

export default component.exports